module.exports = __webpack_public_path__ + "static/media/logo2-Black.a1325a43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo2-Black.png
// module id = 554
// module chunks = 0